import React, { createContext, useState } from "react";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const urlVideos =
    "https://yovzfwnzwyemvxfvpqyw.supabase.co/storage/v1/object/public/videos/";
  const urlFotos =
    "https://yovzfwnzwyemvxfvpqyw.supabase.co/storage/v1/object/public/fotos/";

  const [activarSubir, setActivarSubir] = useState(false);
  const [activarBuscar, setActivarBuscar] = useState(false);
  const [activarLupa, setActivarLupa] = useState(false);

  function activarBuscador(e) {
    setActivarBuscar(e);
  }

  function activarLupaResponsive(e, b) {
    setActivarLupa(e);
    setActivarBuscar(b);
  }

  return (
    <DataContext.Provider
      value={{
        urlVideos,
        urlFotos,
        activarSubir,
        setActivarSubir,
        activarBuscar,
        setActivarBuscar,
        activarBuscador,
        activarLupa,
        setActivarLupa,
        activarLupaResponsive,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
